var customerAnswers = {};

$( document ).ready(function() {
    let buttons = document.getElementsByClassName('quiz__option');
  	let backButtons = document.getElementsByClassName('back-btn');
  
    for (let button of buttons){
      button.addEventListener('click', function(){
        
        if(this.getAttribute('data-type') === 'style'){
          	addStyle(button);
          	nextScreen('type');
          	setTimeout(() => {changePosition('style', 'type');}, 1000);
        }else if (this.getAttribute('data-type') === 'type'){
          	addType(button);
          	answerScreen();
          	nextScreen('final');
        	$('body').animate({ scrollTop: 100 }, 1000);
          	setTimeout(() => {changePosition('type', 'final');}, 1000);
        }  
      });
    }
  
  	for (let backBtn of backButtons){
      backBtn.addEventListener('click', function(){
       
        if(this.getAttribute('data-type') === 'type'){
          	backScreen('type')
            changePosition('type', 'style');
          	
        } else if (this.getAttribute('data-type') === 'final'){
        	backScreen('final')
            changePosition('final', 'type');

        }
      });
    }
});


function addStyle(button){
	let answer = button.getAttribute("data-answer");
   	
  	customerAnswers['style'] = (answer);
}

function addType(button){
	let answer = button.getAttribute("data-answer");
   	
  	customerAnswers['type'] = (answer);
}


function nextScreen(nextScreen){
	let nextId = nextScreen+'_of_hair';
    let screen = document.getElementById(nextId);
    screen.style.left = '0px';
  	
  	$('body').animate({ scrollTop: 100 }, 1000);
}

function backScreen(currentScreen){
	let currentId = currentScreen+'_of_hair';
  	let screen = document.getElementById(currentId);
    screen.style.left = '-9999px';
  	
  	$('body').animate({ scrollTop: 100 }, 1000);
}

function answerScreen(){
  let answer_style = customerAnswers.style;
  let answer_type = customerAnswers.type;
  let answerContainer = document.getElementById('answer');

  answerContainer.innerHTML = answers[answer_style][answer_type]
}

function changePosition(current, next){
	let currentId = current+'_of_hair';
  	let nextId = next+'_of_hair';
  	
  	let currentScreen = document.getElementById(currentId)
    let nextScreen = document.getElementById(nextId)
    
    currentScreen.style.position = 'absolute'
    nextScreen.style.position = 'relative'
}


//Arrow functions
var firstButton = document.getElementById('first-arrow-right');
firstButton.onclick = function () {
    var container = document.getElementsByClassName('first-container')[0];
    var distance = 255;
    sideScroll(container,'right',50,distance,35);
};

var firstBack = document.getElementById('first-arrow-left');
firstBack.onclick = function () {
    var container = document.getElementsByClassName('first-container')[0];
    var distance = 255;
    sideScroll(container,'left',50,distance,35);
};

var secondButton = document.getElementById('second-arrow-right');
secondButton.onclick = function () {
    var container = document.getElementsByClassName('second-container')[0];
    var distance = 255;
    sideScroll(container,'right',50,distance,35);
};

var secondBack = document.getElementById('second-arrow-left');
secondBack.onclick = function () {
    var container = document.getElementsByClassName('second-container')[0];
    var distance = 255;
    sideScroll(container,'left',50,distance,35);
};

function sideScroll(element,direction,speed,distance,step){
    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}  
